import { inject, Injectable } from '@angular/core';
import { BaseSynchronizeService } from "@core/services/synchronize/synchronize.service";
import { TripRequest, TripService } from "@api/api";
import { TripIndexedDbService } from "@core/storage/indexedDb/trip-database.service";
import { Trip } from "@core/api";

@Injectable({
  providedIn: 'root',
})
export class TripSynchronizeService extends BaseSynchronizeService<Trip> {
  database = inject(TripIndexedDbService);
  tripService = inject(TripService);
  apiFunction = (data: Trip) => {
    const departure = data.departure;
    const arrival = data.arrival;
    const tripRequest = {
      vehicleId: departure.vehicleId,
      reason: departure.reason,
      startDateTime: departure.startDateTime.toISOString(),
      startNotes: departure.startNotes,
      startOdometer: departure.startOdometer,
      startAddress: departure.startAddress,
      startLocation: departure.startLocation,
      endDateTime: arrival.endDateTime.toISOString(),
      endNotes: arrival.endNotes,
      endOdometer: arrival.endOdometer,
      endAddress: arrival.endAddress,
      endLocation: arrival.endLocation
    } as TripRequest;

    return this.tripService.createTrip(tripRequest, departure.startOdometerPhoto, arrival.endOdometerPhoto);
  };
}
